<template>
    <el-dialog custom-class="verification-dialog-class" title="核销卡密" :visible.sync="visible" @close="close" width="400px" :close-on-click-modal="false">
        <div class="dialog-box">
            <div class="dialog-info-box">
                <div class="dialog-info-item">
                    <div class="dialog-info-item-label">订单编号：</div>
                    <div class="dialog-info-item-value">{{item.order_id}}</div>
                </div>
                <div class="dialog-info-item">
                    <div class="dialog-info-item-label">订单面值：</div>
                    <div class="dialog-info-item-value">{{item.add_gold}}</div>
                </div>
                <div class="dialog-info-item">
                    <div class="dialog-info-item-label">下单时间：</div>
                    <div class="dialog-info-item-value">{{item.add_time}}</div>
                </div>
            </div>
            <div class="dialog-form-box"> 
                <el-form :model="form" :rules="rules" ref="form" size="mini" label-position="left" label-width="90px">
                    <el-form-item label="卡号:" prop="card">
                        <el-input v-model="form.card" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                    </el-form-item>  
                    <el-form-item label="卡密:" prop="pwd">
                        <el-input v-model="form.pwd" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                        <div class="cdanger form-error-div">{{pwdError}}</div>
                    </el-form-item>  
                    <el-form-item label="备注:" prop="">
                        <el-input v-model="form.note" type="textarea" :rows="3" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
                    
                    </el-form-item>                        
                        
                </el-form> 
            </div>                    
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close" :disabled="loading" >取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">核 销</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        pwdError:{  
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: {
                card: '',
                pwd: '',
                note: ''
            },
            rules:{
                card:[{ required: true, message: '卡号不能为空', trigger: 'blur' }],
                pwd:[{ required: true, message: '卡密不能为空', trigger: 'blur' }],                
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')            
            this.$refs['form'].resetFields();
        },
        sure(){
            this.$refs['form'].validate((valid) => {
                    if (valid) {
                        console.log('======')
                        this.$emit("ensure",this.form,this.item.id)
                        
                    } else {
                        return false;
                    }
                }); 
        }
    }
}
</script>
<style lang="scss" scoped>
       .verification-dialog-class{
            .dialog-box{
                max-height:70vh !important;
                overflow-y:auto;
                .dialog-info-box{
                    .dialog-info-item{
                        display:flex;
                        justify-content: flex-start;
                        align-items:center;
                        margin-bottom: 14px;
                        .dialog-info-item-label{
                            // width: 80px;
                            white-space:nowrap;
                            // margin-right: 10px;
                        }
                        .dialog-info-item-value{
                            flex:1;
                        }
                    }
                }
                .dialog-form-box{
                    margin-top: 36px;
                    .dialog-div-input{
                        // width: 200px;
                    }
                    .form-error-div{
                        padding-left:90px;
                    }
                }
            }
        }
</style>